import React, { createContext, useContext, useState } from 'react';

import CustomDialog from '@components/common/Modal/CustomDialog';

const DialogContext = createContext();

export const useDialog = () => useContext(DialogContext);

const initialDialogState = {
  type: 'alert',
  open: false,
  title: '',
  message: '',
  showCloseButton: true,
  cancelText: '취소',
  confirmText: '확인',
  onConfirm: null,
  onCancel: null,
  nested: null,
};

export const DialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState(initialDialogState);

  const showDialog = ({
    type = 'alert',
    title,
    message,
    showCloseButton = true,
    cancelText = '취소',
    confirmText = '확인',
    onConfirm = null,
    onCancel = null,
    nested = null,
  }) => {
    setDialogState({
      type,
      open: true,
      title,
      message,
      showCloseButton,
      cancelText,
      confirmText,
      onConfirm,
      onCancel,
      nested,
    });
  };

  const hideDialog = () => {
    setDialogState((prev) => ({ ...prev, open: false }));
  };

  return (
    <DialogContext.Provider value={{ showDialog, hideDialog }}>
      <CustomDialog {...dialogState} onClose={hideDialog} />
      {children}
    </DialogContext.Provider>
  );
};
